// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fixed-container[data-v-c4485c28]{position:fixed;width:100vw;height:100vh;top:0;left:0;display:flex;justify-content:flex-end;align-items:flex-end;pointer-events:none;z-index:1000}.toast-container[data-v-c4485c28]{padding-right:20px;padding-bottom:20px}.toast-container[data-v-c4485c28]:not(:first-child){margin-top:20px}", ""]);
// Exports
module.exports = exports;
